import { Box, CircularProgress } from '@ltvco/refresh-lib/theme';
import { useFeatureIsOn, useGrowthBook } from '@ltvco/refresh-lib/vendors';
import { Navigate, Route, Routes } from 'react-router-dom';

import { DeepSearchProvider } from '../context';

import { DeepSearchPage } from './DeepSearchPage';
import { LoadingContainer } from './DeepSearchPage.styles';

export const DeepSearchContainer = () => {
  const gb = useGrowthBook();
  const isInDeepSearchVariation = useFeatureIsOn('prop-3834');

  if (!gb?.ready) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  if (!isInDeepSearchVariation) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DeepSearchProvider>
        <Routes>
          <Route path="/*" element={<DeepSearchPage />} />
        </Routes>
      </DeepSearchProvider>
    </Box>
  );
};
